<div class="box box-items-center background-25 pad-hor pad-vert">
    <img src="icons/cloud-compile.png" width="128px" alt="" />
    <span class="foreground-cc font-small pad-vert font-x-large">
        ShnooTalk Playground
    </span>
    <div class="box font-small box-items-center pad-hor">
        <a
            href="https://github.com/RainingComputers/ShnooTalk"
            class="foreground-cc text-no-wrap"
            target="_blank"
        >
            github.com/RainingComputers/ShnooTalk
        </a>

        <a
            href="https://github.com/RainingComputers/shnootalk-playground"
            class="foreground-cc text-no-wrap"
            target="_blank"
        >
            github.com/RainingComputers/shnootalk-playground
        </a>

        <span
            class="foreground-f80 text-no-wrap foreground-f80 pad-vert"
            style="font-size: xx-small;"
        >
            © Copyrights 2021 RainingComputers
        </span>
    </div>
</div>
